import { TwoColumnsGridContainer } from '../styled/IllustrativeGrid.style.ts'

export interface IllustrativeGridProps {
    items: any[]
}

const IllustrativeGrid = (props: IllustrativeGridProps) => {
    const { items } = props
    return (
        <>
            <TwoColumnsGridContainer>
                {items}
            </TwoColumnsGridContainer>
        </>
    )
}

export default IllustrativeGrid